var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NotifyClient } from '@juvare/platform-sdk-js/NotifyClient';
import { AlertBaseClient } from './AlertBaseClient';
/**
 * @deprecated all new code needs to go to `AlertServiceClient.ts`.
 */
class AlertsClient extends AlertBaseClient {
    constructor(baseUrl) {
        const notifyClient = new NotifyClient();
        super({ onTokenRequest: () => notifyClient.getAlertToken().then((result) => result.token) }, baseUrl);
        this.getAlert = (id, excludeFields) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/v1/alerts/' + id + (excludeFields ? '?excludeFields=' + excludeFields : ''),
            });
            return response.data;
        });
        this.getAlertMetadata = (id) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: `/v1/alerts/${id}/metadata`,
            });
            return response.data;
        });
        this.getAlerts = (page, size, statuses, fieldFilter, sort) => __awaiter(this, void 0, void 0, function* () {
            const filters = [];
            let sorting = '';
            if (fieldFilter) {
                filters.push('');
                fieldFilter.forEach((field) => {
                    if (field.field === 'dateSent' || field.field === 'dateCreated') {
                        const filter = JSON.parse(JSON.stringify(field.value));
                        if (filter.dateFrom) {
                            this.pushFilterValue(filters, field.field, filter.dateFrom.toString(), 'From');
                        }
                        if (filter.dateTo) {
                            this.pushFilterValue(filters, field.field, filter.dateTo.toString(), 'To');
                        }
                    }
                    else {
                        this.pushFilterValue(filters, field.field, field.value.toString(), '');
                    }
                });
            }
            if (sort && sort.length > 0) {
                sorting += '&sortBy=' + sort[0].field + '&ascending=' + !sort[0].desc;
            }
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/v1/alerts?page=' + page + '&size=' + size + '&statuses=' + statuses + filters.join('&') + sorting,
            });
            return response.data;
        });
        this.pushFilterValue = (filters, field, filter, prefix) => {
            filters.push(encodeURIComponent(field) + prefix + '=' + encodeURIComponent(filter));
        };
        // TODO use platform function
        // saveAlert = (alert: ApiSaveAlertRequest): Promise<ApiAlertResponse> => {
        //     return this.http.post('/v1/alerts/', JSON.stringify(alert));
        // };
        //
        // updateAlert = (alertId: string, alert: ApiSaveAlertRequest): Promise<ApiAlertResponse> => {
        //     return this.http.put('/v1/alerts/' + alertId, JSON.stringify(alert));
        // };
        this.deleteAlert = (alertId) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'DELETE',
                url: '/v1/alerts/' + alertId,
            });
            return response.data;
        });
        // validate = (alert: ApiSaveAlertRequest): Promise<void> => {
        //     return this.http.post('/v1/alert/validate', JSON.stringify(alert));
        // };
        this.cancelAlert = (alertId) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'PUT',
                url: `/v1/alerts/${alertId}/cancel`,
                data: {},
            });
            return response.data;
        });
        this.terminateAlert = (alertId) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'PUT',
                url: `/v1/alerts/${alertId}/terminate`,
                data: {},
            });
            return response.data;
        });
        this.archiveAlert = (alertId) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'PUT',
                url: `/v1/alerts/${alertId}/archive`,
                data: {},
            });
            return response.data;
        });
        this.getAlertResponders = (id, parameters) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/v1/alerts/' + id + '/responder-searches?page=' + parameters.page + '&size=' + parameters.pageSize,
                data: {
                    status: parameters.status,
                    responses: parameters.responses,
                    alertResponderFields: ['externalId', 'name', 'status', 'responseOptionId', 'responseTime'],
                },
            });
            return response.data;
        });
        this.getAllAlertResponders = (id, parameters) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/v1/alerts/' + id + '/responders',
                data: {
                    status: parameters.status,
                    responses: parameters.responses,
                },
            });
            return response.data;
        });
        this.pinAlert = (alertId, alertPins) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'PUT',
                url: `/v1/alerts/${alertId}/pin`,
                data: alertPins,
            });
            return response.data;
        });
        this.orderAlert = (alertId, orderIndex) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'PUT',
                url: `/v1/alerts/${alertId}/order?orderIndex=${orderIndex}`,
                data: {},
            });
            return response.data;
        });
    }
}
export default AlertsClient;
